// removed by extract-text-webpack-plugin
module.exports = {"accumulatorBoost":"JP2fBD7obK0SwzShuZ7bi","title":"_1xVoUHHVJ5XhL-ZsiAcZam","content":"_2-oH7IOTl4lYDJhUDFinhT","tableStyle":"_3VRlONeB1HojbfwP-x-pZ0"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/accumulatorBoostScreen.css
// module id = 879
// module chunks = 0